import React from 'react';
import PropTypes from 'prop-types';

export const ServerVarsContext = React.createContext({});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export function ServerVarsContextProvider({ children, isDesktop, isMobile, isTablet }) {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isTablet,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
}

ServerVarsContextProvider.defaultProps = {
    clientConf: {},
};

ServerVarsContextProvider.propTypes = {
    children: PropTypes.node,
    isDesktop: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
};
